
const Errors = {
    1: { message: 'Generic Error', detail: 'Errore Generico' },
    2: { message: 'Unauthorized', detail: 'Non Autorizzato' },
    3: { message: 'Not Found', detail: 'Non Trovato' },
    4: { message: 'Upload Error', detail: 'Errore nel caricamento' },
    5: { message: 'Already Exists', detail: 'Già Esistente' },
    6: { message: 'Invalid Credentials', detail: 'Credenziali non valide' },
    7: { message: 'Cannot Access', detail: 'Accesso Negato' },
    8: { message: 'Stripe Error', detail: 'Errore Stripe' },
    9: { message: 'Profile Suspended', detail: 'Profilo Sospeso' },
    10: { message: 'Account Locked', detail: 'Account Bloccato' },
    11: { message: 'Missing Field', detail: 'Campo Mancante' },
    12: { message: 'Profile Not Found', detail: 'Profilo Non Trovato' },
    13: { message: 'Teacher Not Found', detail: 'Insegnante Non Trovato' },
    14: { message: 'Verification Email Not Sent', detail: 'Email di verifica non inviata' },
    15: { message: 'Password Reset Email Not Sent', detail: 'Email di reset password non inviata' },
    16: { message: 'Hosting Error', detail: 'Errore dell\' hosting' },
    17: { message: 'Application Not Found', detail: 'Candidatura non trovata' },
    18: { message: 'Mail Error', detail: 'Errore nell\'invio della mail' },
    19: { message: 'Invalid Field', detail: 'Campo non valido' },
    20: { message: 'Subscription Error', detail: 'Errore di iscrizione' },
    21: { message: 'Expired', detail: 'Scaduto' },
    22: { message: 'Timeout', detail: 'Timeout' },

}

export function mapServerError (error) {
    if (!error.code) return error;

    const mappedError = Errors[error.code];
    return mappedError ? mappedError : error;
}